// extracted by mini-css-extract-plugin
export default {"colorOption":"colorOption__tLhEz","sample":"sample__vk70W","picker":"picker__GOV7O"};